import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LoadingProService } from '../../services/loading-pro.service';

@Component({
  selector: 'app-loading-pro',
  templateUrl: './loading-pro.component.html',
  styleUrls: ['./loading-pro.component.scss']
})
export class LoadingProComponent implements OnInit, OnDestroy {

  //Variable that shows and hides the loading
  isLoading: BehaviorSubject<boolean>;
  isLoadingNextOp: BehaviorSubject<boolean>;
  isProcessRestarted: BehaviorSubject<boolean>;
  operation: Record<'text' | 'icon', string>;
  subscription: Subscription;

  constructor(public _loadingProService: LoadingProService) { }

  ngOnInit(): void {
    this.isLoading = this._loadingProService.isActive;
    this.isLoadingNextOp = this._loadingProService.isNextOpActive;
    this.isProcessRestarted = this._loadingProService.isProcessRestarted;
    this.subscription = this._loadingProService.operation.subscribe((value) => {
      if(value) {
        this.operation = value;
      }
    });
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
